/**
 * Number of buildable plots per zone (DS-28). Free placement means the
 * player picks where a building goes rather than the surface deriving a
 * position from the building's identity, so plot identity has to live here
 * — shared, not just in the client's `surfaceLayout.ts` — because the
 * server validates a plot choice against it.
 *
 * Each zone gets two more plots than it has buildings
 * (`BUILDING_DEFINITIONS`, asserted by `plots.test.ts`): with exactly one
 * plot per building, placement stops being a real choice the moment a zone
 * nears full — the tail end of the game would force every last building
 * onto whatever plot is left. A couple of spares keeps a choice available
 * even in a nearly-built zone without meaningfully changing the pacing.
 */
const PLOT_COUNT = {
    resource: 8,
    industry: 9,
    military: 6,
};
function plotIdsForZone(zone, count) {
    return Array.from({ length: count }, (_, index) => `${zone}-${index + 1}`);
}
/**
 * Every buildable plot id, grouped by zone — `resource-1`…`resource-8`,
 * `industry-1`…`industry-9`, `military-1`…`military-6`. The server validates
 * a construct's chosen plot against this; the client's `surfaceLayout.ts`
 * keys its visual (`worldX`/`depth`) data by these same ids.
 */
export const SURFACE_PLOT_IDS = {
    resource: plotIdsForZone("resource", PLOT_COUNT.resource),
    industry: plotIdsForZone("industry", PLOT_COUNT.industry),
    military: plotIdsForZone("military", PLOT_COUNT.military),
};
//# sourceMappingURL=plots.js.map